export const errorPages = {
    'error.page.404.title': 'Error 404',
    'error.page.404.text': "Were you looking for something here? There doesn't seem to be anything here anymore",
    'error.page.500.title': 'Error 500',
    'error.page.500.text': 'Something seems to have gone wrong. We are already working on troubleshooting the issue, try logging in to the platform after a while',
    'error.page.503.title': 'Error 503',
    'error.page.503.text': 'Right now the server is temporarily unavailable, but we are already working on the situation. Please wait a while and try to log back in',
    'error.page.support.button': 'Do you have a question? Write to our support team',
}
